import { useState } from 'react';
import { AdSlot } from 'react-dfp';
import { safeMemo } from '../../../../common/util/safeMemo';
import { PHISlide } from '../../../Slide/PHISlide';
import { SearchResultItem } from '../../../types';
import { GpTelehealthCard } from '../teleSuggestion/GpTelehealthCard/GpTelehealthCard';
import { PracticeCard } from './search-card/PracticeCard/PracticeCard';
import { PractitionerCard } from './search-card/PractitionerCard/PractitionerCard';
import { SearchAdCard } from './search-card/SearchAdCard/SearchAdCard';
import { Spacer } from './search-card/card.styles';

interface Props {
  card: SearchResultItem;
  index: number;
  searchSpecialty?: string;
  resultType: 'standard' | 'extended';
  inSearchedSuburb?: boolean;
}

export const ProfileCard = safeMemo(
  ({ index, card, searchSpecialty, resultType, inSearchedSuburb }: Props) => {
    const [adRendered, setAdRendered] = useState(false);

    switch (card.type) {
      case 'practice':
        return (
          <PracticeCard
            practice={card}
            index={index}
            searchSpecialty={searchSpecialty}
            resultType={resultType}
            inSearchedSuburb={inSearchedSuburb}
          />
        );
      case 'practitioner':
        return (
          <PractitionerCard
            practitioner={card}
            index={index}
            searchSpecialty={searchSpecialty}
            resultType={resultType}
            inSearchedSuburb={inSearchedSuburb}
          />
        );
      case 'ad':
        return (
          <>
            <SearchAdCard ad={card} />
          </>
        );

      case 'gam-ad':
        // This ads using AdSlot instead of generic GoogleGAMAd because native ads already have built in 'Advertisment` text indicator
        return (
          <>
            <AdSlot
              adUnit="HealthEngine.web/results"
              slotId={`gam_native_pos${card.id}`}
              sizes={['fluid']}
              targetingArguments={{
                pos: `${card.id}`,
                native: 'infeed',
              }}
              onSlotIsViewable={() => setAdRendered(true)}
            />
            {adRendered && <Spacer />}
          </>
        );

      case 'suggestion':
        switch (card.id) {
          case 'gpOrTelehealth':
            return <GpTelehealthCard />;
          default:
            return null;
        }

      case 'phiSlide':
        return <PHISlide />;

      default:
        return null;
    }
  },
);
